export default __webpack_public_path__ + "static/media/Omega Application.2d01cece.png";